export const backdrop = (theme) => ({
    backgroundColor: `${theme.colors?.effects.shadowColor}40`,
});
//# sourceMappingURL=backdrop.js.map